import React from "react";
import { Icon } from "@mui/material";
import { MdCheck } from "react-icons/md";
import { VerifyAdornmentProps } from ".";

function VerifyAdornment({ correct }: VerifyAdornmentProps) {
  return (
    <Icon
      sx={theme => ({
        color: correct ? theme.palette.primary.main : theme.palette.grey[400],
        opacity: correct ? 1 : 0.2
      })}
    >
      <MdCheck fontSize={16} className="transition-all duration-500 ml-auto mt-1" />
    </Icon>
  );
}

export default VerifyAdornment;
